<template>
  <div>
    <!-- Media -->
    <b-media class="mb-2">
      <template #aside>
        <b-avatar
          ref="previewEl"
          :src="userData.avatar"
          size="90px"
          rounded
        />
      </template>
      <h4 class="mb-1">
        {{ userData.titleName }} {{ userData.firstName }} {{ userData.lastName }}
      </h4>
      <span class="card-text">{{ userData.idCardNumber }}</span>
    </b-media>

    <!-- Header: Personal Info -->
    <div class="d-flex">
      <feather-icon
        icon="CreditCardIcon"
        size="19"
      />
      <h4 class="mb-0 ml-50">
        Account Details
      </h4>
    </div>

    <b-form class="mt-1">
      <b-row>
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="Bank Account Number"
            label-for="bankAccountNumber"
          >
            <b-form-input
              id="bankAccountNumber"
              v-model="userData.bankAccountNumber"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="Bank Account Name"
            label-for="bankAccountName"
          >
            <b-form-input
              id="bankAccountName"
              v-model="userData.bankAccountName"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="Bank Name"
            label-for="bankName"
          >
            <v-select
              v-model="userData.bankName"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="bankOptions"
              :reduce="val => val.value"
              :clearable="false"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="Bank Branch Name"
            label-for="bankBranchName"
          >
            <b-form-input
              id="bankBranchName"
              v-model="userData.bankBranchName"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="Remark"
            label-for="remark"
          >
            <b-form-textarea
              id="remark"
              v-model="userData.remark"
              rows="3"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="Attach File"
            label-for="file"
          >
            <b-form-file
              v-model="file"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col>
          <b-button
            variant="primary"
            class="mb-1 mb-sm-0 mr-0 mr-sm-1"
            :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          >
            Save Changes
          </b-button>
          <b-button
            variant="outline-secondary"
            :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          >
            Reset
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import {
  BRow, BCol, BForm, BFormGroup, BFormInput, BButton, BInputGroup,
  BInputGroupPrepend, BMedia, BAvatar, BFormTextarea, BFormFile,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BInputGroup,
    BInputGroupPrepend,
    BMedia,
    BAvatar,
    BFormTextarea,
    BFormFile,
    vSelect,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      file: null,
    }
  },
  setup() {
    const bankOptions = [
      { label: 'Bangkok bank', value: 'bbl' },
      { label: 'Kasikorn', value: 'kbank' },
      { label: 'Krungsri', value: 'krungsri' },
    ]

    return {
      bankOptions,
    }
  },
}
</script>

<style>

</style>
